import { createRouter, createWebHistory, START_LOCATION } from 'vue-router';
import mainLayout from '@/layouts/main-layout/main-layout.vue';
import appDepartLayout from '@/layouts/app-depart-layout/app-depart-layout.vue';
import authLayout from '@/layouts/auth-layout/auth-layout.vue';
import loginForm from '@/views/auth/login-form.vue';
import restoreForm from '@/views/auth/restore-form.vue';
import setPasswordForm from '@/views/auth/set-password-form.vue';
import store from '@/store';
import { getRouter, getRouterDataByFullPath } from '@/utils/meta-route';
import systemSettingsView from '@/views/administration/settings/systemSettingsView.vue';
import AccessDenied from '@/views/access-denied/access-denied.vue';
import { getCookie, setCookie } from './utils/cookies';
import enviromentStore from '@/store/enviroment-data';
import { getFuncRefreshOpenTabs, tabFocusChange } from '@/layouts/main-layout/components/navigation-bars-data';
import { setChangeRouteFunc, setIsReloadValue, setViewId } from './layouts/main-layout/main-layout-data';

const { checkAccess, setCurrentUiRouteRightByRoutePath } = enviromentStore;

export let routes = [
    {
        path: '/infoenergo/login',
        name: 'loginForm',
        meta: {
            requiresAuth: false,
            layout: authLayout,
        },
        component: loginForm,
    },
    {
        path: '/infoenergo/system-settings',
        name: 'SystemSettings',
        meta: { requiresAuth: true, layout: mainLayout },
        component: systemSettingsView,
        viewId: 'SystemSettings',
    },
    {
        path: '/infoenergo/restore',
        name: 'infoenergo/restore',
        meta: {
            requiresAuth: false,
            layout: authLayout,
        },
        component: restoreForm,
    },
    {
        path: '/infoenergo/setpassword/&/:uuid',
        name: 'set-password-form',
        meta: {
            requiresAuth: false,
            layout: authLayout,
        },
        component: setPasswordForm,
    },
    {
        path: '/',
        redirect: '/infoenergo/app-depart',
    },
    {
        path: '/infoenergo',
        redirect: '/infoenergo/app-depart',
    },
    {
        path: '/infoenergo/app-depart',
        name: 'AppDepartmentSelect',
        viewId: 'AppDepartmentSelect',
        meta: { requiresAuth: true, layout: appDepartLayout },
        component: appDepartLayout,
    },
    {
        path: '/infoenergo/access-is-denied/&/:app/:dep',
        name: 'access-denided',
        viewId: 'access-denided',
        title: 'Доступ запрещен',
        meta: { requiresAuth: true, layout: mainLayout },
        component: AccessDenied,
    },
];
export let initialRoutes = [
    {
        path: '/infoenergo/login',
        name: 'loginForm',
        meta: {
            requiresAuth: false,
            layout: authLayout,
        },
        component: loginForm,
    },
    {
        path: '/infoenergo/system-settings',
        name: 'SystemSettings',
        meta: { requiresAuth: true, layout: mainLayout },
        component: systemSettingsView,
        viewId: 'SystemSettings',
    },
    {
        path: '/infoenergo/restore',
        name: 'infoenergo/restore',
        meta: {
            requiresAuth: false,
            layout: authLayout,
        },
        component: restoreForm,
    },
    {
        path: '/infoenergo/setpassword/&/:uuid',
        name: 'set-password-form',
        meta: {
            requiresAuth: false,
            layout: authLayout,
        },
        component: setPasswordForm,
    },
    {
        path: '/',
        redirect: '/infoenergo/app-depart',
    },
    {
        path: '/infoenergo',
        redirect: '/infoenergo/app-depart',
    },
    {
        path: '/infoenergo/app-depart',
        name: 'AppDepartmentSelect',
        viewId: 'AppDepartmentSelect',
        meta: { requiresAuth: true, layout: appDepartLayout },
        component: appDepartLayout,
    },
    {
        path: '/infoenergo/access-is-denied/&/:app/:dep',
        name: 'access-denided',
        viewId: 'access-denided',
        title: 'Доступ запрещен',
        meta: { requiresAuth: true, layout: mainLayout },
        component: AccessDenied,
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes: routes,
});

router.afterEach(async (to, from) => {
    setChangeRouteFunc(to.fullPath);

    // await setViewData();
    const token = getCookie('token');
    let routeName = to.name;
    setViewId(to.meta.viewId);

    const isReload = from.fullPath !== '/' && to.fullPath !== from.fullPath ? false : true;
    setIsReloadValue(isReload);
    // в этот if мы попадаем в случае директивного изменения урла ручками,
    // так как vue-router теряет историю роутинга после f5 (refreah)
    // основная проверка роутов на доступ происходит в main.js в функции proccessRouting ( beforeEnter функция для каждого из генерируемых роутов)

    if (!to.redirectedFrom) {
        if (to.name !== 'access-denided') {
            const getRouterNameByFullPathRes = await getRouterDataByFullPath(to.fullPath);
            const hasAccess = await checkAccess(
                routeName ? routeName : getRouterNameByFullPathRes.data.route_name,
                token
            );
            if (hasAccess && !getRouterNameByFullPathRes.data.is_child) {
                router.push({ name: 'access-denided', params: { app: getCookie('app'), dep: getCookie('dep') } });
            }
            if (!routeName) {
                routeName = getRouterNameByFullPathRes.data.route_name;
            }
        }
    }

    if (!router.hasRoute(routeName)) {
        if (routeName !== undefined) {
            const newRout = await getRouter(routeName);
            if (newRout.result === true) {
                router.addRoute(newRout.data);
                await router.replace(router.currentRoute.value.fullPath);
            }
        }
    }

    // Внутрений роутинг по табам - без него не корректно работают карточки
    // или любые другие объекты зависящие от viewId и instanseId
    if (!initialRoutes.find(item => item.name === to.name)) {
        if (to.name !== store.state.userDataDetails.focusedRouteName) {
            const payload = { routeName: to.name, routerPath: to.fullPath, params: to.params };
            if (to.params.id) {
                payload.id = Number(to.params.id);
            }
            await tabFocusChange(payload);
            const func = getFuncRefreshOpenTabs();
            if (func) {
                await func();
            }
        }
        await setCurrentUiRouteRightByRoutePath(to.path);
    }
});

router.beforeEach(async (to, from) => {
    if (from === START_LOCATION) {
        console.log('START_LOCATION');
    }
    const appId = to.params.app;
    const depId = to.params.dep;

    if (appId) {
        setCookie('app', appId);
    }

    if (depId) {
        setCookie('dep', depId);
    }
});

// router.beforeResolve(to => {
//     console.log('beforeResolve', to);
// });

export default router;
